import _ from 'lodash';
import {
    NEXT_STEP,
    RESET_STEPS,
    TOGGLE_VISIBILITY,
} from '../actions/actionCreators/introductionLayer';

const initialState = {
    step: 1,
    isOpen: false,
};

export default function introductionLayer(state = initialState, action) {
    let newState = _.cloneDeep(state);
    switch (action.type) {
        case NEXT_STEP:
            newState.step = newState.step + 1;
            return newState;
        case RESET_STEPS:
            newState.step = initialState.step;
            return newState;
        case TOGGLE_VISIBILITY:
            newState.isOpen = !newState.isOpen;
            return newState;
        default:
            return state;
    }
}
